<template>
    <div>
        <div v-if="sModoCampo=='1'">
            <span class="text-label-primary">
                {{ onValidarPlaceholder(sLabel) }} <span v-if="bObligatorio" class="red--text">*</span>
            </span>
            <v-textarea
                v-model="valor"
                v-bind="oAtributos"
                class="mt-1"
                dense
                :placeholder="sPlaceholderTemp==''?sPlaceholder:sPlaceholderTemp"
                auto-grow
                rows="1"
                @input="validateInput"
            />
        </div>
        <div v-else>
            <span class="text-label-primary segundoEstiloTitulo mb-2">
                {{ onValidarPlaceholder(sLabel) }} <span v-if="bObligatorio" class="red--text">*</span>
            </span>
            <v-textarea
                v-model="valor"
                v-bind="oAtributos"
                class="mt-1 custom-border"
                dense
                outlined
                :placeholder="sPlaceholderTemp==''?sPlaceholder:sPlaceholderTemp"
                auto-grow
                rows="1"
                :error="bError"
                @input="validateInput"
                hide-details
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormTexto',
    props: {
        value: {
            type: String,
            default: ''
        },
        oAtributos: {
            type: Object,
            default: () => {}
        },
        bObligatorio: {
            type: Boolean,
            default: false
        },
        sLabel: {
            type: String,
            default: ''
        },
        sModoCampo:{
            type: String,
            default: "1",
        },
        sGrupo:{
            type: String,
            default: "",
        },
        bError:{
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            valor: this.value,
            sPlaceholderTemp:""
        }
    },
    watch: {
        valor(NewValor) {
            this.$emit('input', NewValor)
        },
        value(NewValor) {
            this.valor = NewValor
        }
    },
    methods: {
        validateInput() {
            // Remueve comillas simples y dobles
            this.valor = this.valor.replace(/['"]/g, '')
        },
        onValidarPlaceholder(sLabelTemp){
            if(sLabelTemp!=""){
                let aTempPlaceholder = sLabelTemp.split("$$");
                if(aTempPlaceholder?.length>0){
                this.sPlaceholderTemp = aTempPlaceholder[1]
                }
                return aTempPlaceholder[0]
            }
        }
    }
}
</script>

<style scoped>
.segundoEstiloTitulo{
  color: #0056D3;
  font-size: medium;
}
</style>
